import { render } from "./HomeView.vue?vue&type=template&id=02497e5e"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "@/assets/css/style-books.css?vue&type=style&index=0&lang=css"
import "./HomeView.vue?vue&type=style&index=1&id=02497e5e&lang=scss"

import exportComponent from "/var/www/sites/qiyas.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__